export default __webpack_public_path__ + "static/media/collapse.1f2f7d60.svg";